var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container language-selection"},_vm._l((_vm.languages),function(lang){return _c('div',{key:lang,staticClass:"flag-container",class:{ 'selected' : _vm.language === lang },on:{"click":() => _vm.changeLanguage(lang)}},[_c('img',{attrs:{"src":_vm.getFlagImage(lang),"alt":`${lang}-flag`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }